// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-item[data-v-4ae92702]{line-height:32px}.list-item-option[data-v-4ae92702]{display:flex;justify-content:space-between;align-items:center;background:#fff;cursor:pointer}.list-item-option .title[data-v-4ae92702]{color:#242424;font-size:14px;width:220px}.list-item-option .time[data-v-4ae92702]{white-space:nowrap;font-weight:400;font-size:14px;color:#333;line-height:28px;margin-left:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
